var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Completed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completed",
    clipPath: "url(#clip-Completed)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_621",
    "data-name": "Ellipse 621",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1 1)",
    fill: "#8bc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20274",
    "data-name": "Path 20274",
    d: "M-10355.57,2587.712l1.761,2.441,5.278-5.1",
    transform: "translate(10361.551 -2577.557)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.65e6c080b1beb95c1ecaa5f09d893453.svg";
export { ForwardRef as ReactComponent };